import { CuttingCadModelMaterialLink } from './cutting-cad-model-material-link.model';
import { DraftBlock } from './cutting-draft-block.model';

export enum LoadingState {
  FileUploaded,
  MaterialParsed,
  MaterialLinked,
  MaterialReplaced,
  NeedConvertation,
  Uploading,
  NeedSetDraftBlocksMode,
}

export class CuttingCadModel {
  id: number;
  guid: string;
  sign: string;
  filename: string;
  fileSize: number;
  count: number;
  state: LoadingState;
  dateUpload: Date;
  parsedMaterials: CuttingCadModelMaterialLink[];
  draftBlocks: DraftBlock[];
  isUnlicensed: boolean;
  isPaid: boolean;
  hasDetailsInfo: boolean;

  constructor(model?: CuttingCadModel | any) {
    model = model || {};
    this.id = model.id || undefined;
    this.sign = model.sign || '';
    this.guid = model.guid || '';
    this.filename = model.filename || '';
    this.fileSize = model.fileSize || 0;
    this.count = model.count || 0;
    this.dateUpload = model.dateUpload || new Date();
    this.parsedMaterials = model.parsedMaterials || [];
    this.state = model.state || LoadingState.FileUploaded;
    this.state = model.draftBlocks || [];
    this.isUnlicensed = model.isUnlicensed ?? false;
    this.isPaid = model.isPaid ?? false;
    this.hasDetailsInfo = model.hasDetailsInfo ?? false;
  }
}
